<template>
  <v-container grid-list-xs fluid>
    <!-- DATA TABLE -->
    <v-card class="layout row wrap shadow pa-3 mt-3">
      <div class="flex-row justify-space-between align-center grey lighten-4">
        <v-menu offset-y>
          <strong class="title_label pl-2" slot="activator">
            <span>{{ filter.title }}</span>
          </strong>
          <v-list>
            <v-list-tile
              :key="index"
              @click="filter = item"
              v-for="(item, index) in filters"
            >
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-spacer />
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              flat
              v-on="on"
              color="grey darken-2"
              class="ma-0 mr-2 pa-0"
              @click="printTable(false)"
            >
              <v-icon>print</v-icon>
            </v-btn>
          </template>
          <span>Print Table</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              flat
              v-on="on"
              color="grey darken-2"
              class="ma-0 mr-2 pa-0"
              @click="printTable(true)"
            >
              <v-icon>file_download</v-icon>
            </v-btn>
          </template>
          <span>Excel Export</span>
        </v-tooltip>
      </div>

      <v-data-table
        ref="tbl"
        class="flex xs12"
        :headers="headers"
        :loading="loading"
        :items="filteredItems"
        :rows-per-page-items="per_page"
      >
        <template v-slot:items="{ item }">
          <tr>
            <td class="font-weight-bold">
              <router-link :to="`/CSOs/${item.id}`">
                {{ item.name }}
              </router-link>
            </td>
            <td>{{ Number(item.p1_sc) }}</td>
            <td>{{ Number(item.p2_sc) }}</td>
            <td>{{ Number(item.p3_sc) }}</td>
            <td>{{ Number(item.p4_sc) }}</td>
            <td>{{ Number(item.p5_sc) }}</td>
            <td class="font-weight-bold">{{ Number(item.total_sc) }}</td>
            <td :class="item.total_st">{{ item.total_st }}</td>
          </tr>
        </template>
        <template slot="footer">
          <tr class="font-weight-bold">
            <td>{{ summery.name }}</td>
            <td>{{ Number(summery.p1_sc) }}</td>
            <td>{{ Number(summery.p2_sc) }}</td>
            <td>{{ Number(summery.p3_sc) }}</td>
            <td>{{ Number(summery.p4_sc) }}</td>
            <td>{{ Number(summery.p5_sc) }}</td>
            <td colspan="2">{{ Number(summery.total_sc) }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "reports-view",
  data: () => ({
    items: [],
    loading: false,
    programAreas: [],
    filters: [
      {
        title: "All CSOs - Capacity Analysis",
        value: false,
        filterFunc: () => true
      },
      {
        value: "Pending",
        title: "Pending CSOs  - Capacity Analysis",
        filterFunc: item => item.total_st == "Pending"
      },
      {
        value: "Certified",
        title: "Certified CSOs  - Capacity Analysis",
        filterFunc: item => item.total_st == "Certified"
      },
      {
        value: "Deferred",
        title: "Deferred CSOs  - Capacity Analysis",
        filterFunc: item => item.total_st == "Deferred"
      }
    ],
    filter: {
      title: "All CSOs - Capacity Analysis",
      value: false,
      filterFunc: () => true
    }
  }),
  computed: {
    filteredItems() {
      return this.items.filter(x => this.filter.filterFunc(x));
    },
    headers: vm => [
      { text: "CSO Name", value: "name" },
      { text: `${vm.$t("part1")}`, value: "p1_sc", width: "100px" },
      { text: vm.$t("part2"), value: "p2_sc", width: "100px" },
      { text: vm.$t("part3"), value: "p3_sc", width: "100px" },
      { text: vm.$t("part4"), value: "p4_sc", width: "100px" },
      { text: vm.$t("part5"), value: "p5_sc", width: "100px" },
      { text: vm.$t("total"), value: "total_sc", width: "100px" },
      { text: vm.$t("status"), value: "total_st", width: "100px" }
    ],
    summery() {
      let len = this.filteredItems.length,
        p1_sc = 0,
        p2_sc = 0,
        p3_sc = 0,
        p4_sc = 0,
        p5_sc = 0,
        total_sc = 0;
      this.filteredItems.forEach(item => {
        p1_sc += Number(item.p1_sc);
        p2_sc += Number(item.p2_sc);
        p3_sc += Number(item.p3_sc);
        p4_sc += Number(item.p4_sc);
        p5_sc += Number(item.p5_sc);
        total_sc += Number(item.total_sc);
      });
      return {
        name: "Average",
        class: "font-weight-bold",
        p1_sc: Number(p1_sc / len).toFixed(1),
        p2_sc: Number(p2_sc / len).toFixed(1),
        p3_sc: Number(p3_sc / len).toFixed(1),
        p4_sc: Number(p4_sc / len).toFixed(1),
        p5_sc: Number(p5_sc / len).toFixed(1),
        total_sc: Number(total_sc / len).toFixed(1)
      };
    }
  },

  methods: {
    downloadReport() {
      this.axios({
        method: "GET",
        url: `reports?analytical=true&&file=true`,
        responseType: "blob" // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "reports.xlsx");
        document.body.appendChild(link);
        link.click();
      });
    },

    getData() {
      this.loading = true;
      this.axios
        .get(`reports?analytical=true`)
        .then(res => {
          this.items = res.data;
          this.loading = false;
        })
        .catch(vm => (vm.loading = false));
    },

    printTable(excel) {
      let items = [...this.filteredItems];
      items.push(this.summery);
      let data = {
        title: this.$t("analytical_report"),
        items: items,
        headers: this.headers
      };

      if (excel) return this.xl_tables(data, "CSOs");
      this.$store.commit("ReportsModule/setTableData", data);
      this.$router.push("/print");
    }
  },
  created() {
    this.getData();
  }
};
</script>
